import { config } from '@/pageConfig/privacyPolicy/us/en';
import { PrivacyPolicyPageTemplate } from '@/pageTemplate/PrivacyPolicyTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

export default function RentersPage() {
  const { trackEvent } = useAnalyticsContext();
  const { asPath } = useRouter();
  const hideHeader = useMemo(() => asPath.includes('show_header=false'), [asPath]);
  const hideFooter = useMemo(() => asPath.includes('show_footer=false'), [asPath]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => trackEvent('privacy-policy_page.viewed', { variant: 'default' }), []);

  return <PrivacyPolicyPageTemplate config={config} showHeader={!hideHeader} showFooter={!hideFooter} />;
}
